import {store} from "@arboxappv4/shared/src/redux/store";
import {HUGIM_FORM_SETTINGS} from "../../../../../src/constants";

export const getHugFormId = () => {
    const box = store.getState().site.box
    const flags = store.getState().stepper.flags ?? {}
    if(!flags.courseInfo) return null
    const hugimFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === HUGIM_FORM_SETTINGS) ?? []
    if(hugimFormSetting.length === 0) return null
    const hugFormSetting = hugimFormSetting.find(s => s.properties?.hugim?.includes(flags.courseInfo.id))
    return hugFormSetting ? hugFormSetting.properties.form_id : null
}

export const getTrialHugFormId = () => {
    const box = store.getState().site.box
    const hugimFormSetting = box?.boxes_settings?.filter(setting => setting.prop_name === HUGIM_FORM_SETTINGS) ?? []
    if(hugimFormSetting.length === 0) return null
    const trialHugFormSetting = hugimFormSetting.find(s => !!s.properties?.allowTrial)
    return trialHugFormSetting ? trialHugFormSetting.properties.form_id : null
}